// Milestone 4 Forum View — presentation labels/helpers (backend authoritative).
import { api } from "@/lib/api";

export const CONSIDERATION_STATE = {
  scheduled: { label: "Scheduled", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  under_discussion: { label: "Under Discussion", cls: "bg-brand-civic-50 text-brand-civic border-brand-civic/30" },
  voting_open: { label: "Voting Open", cls: "bg-brand-gold-50 text-[#9A7212] border-brand-gold/40" },
  voting_closed: { label: "Voting Closed", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  continued: { label: "Continued", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  completed: { label: "Completed", cls: "bg-brand-teal-50 text-brand-teal border-brand-teal/30" },
};

export const VOTE_META = {
  YES: { label: "Yes", cls: "border-brand-teal text-brand-teal", sel: "bg-brand-teal text-white border-brand-teal" },
  NO: { label: "No", cls: "border-red-500 text-red-600", sel: "bg-red-600 text-white border-red-600" },
  WITHHELD: { label: "Withheld", cls: "border-slate-400 text-slate-600", sel: "bg-slate-700 text-white border-slate-700" },
};

export const OUTCOME_OPTIONS = [
  ["approved", "Approved"], ["denied", "Denied"], ["continued", "Continued"],
  ["tabled", "Tabled"], ["withdrawn", "Withdrawn"], ["no_action", "No Action"],
  ["amended", "Amended"], ["discussed", "Discussed"],
];

export function fmtTime(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }); }
  catch { return iso; }
}

export async function downloadForumFile(meetingId, itemId, att) {
  const res = await api.get(
    `/forum/meetings/${meetingId}/items/${itemId}/attachments/${att.attachment_id}/download`,
    { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = att.title || "document";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
